module.exports = __webpack_public_path__ + "static/media/ios-rewind.791cc679.svg";